/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply each course's grade points by its credit hours, add them up, and divide by the total credit hours. The result is your credit-weighted GPA.`)
};

const es_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplica los puntos de nota de cada asignatura por sus créditos, súmalos y divide entre el total de créditos. El resultado es tu GPA ponderado por créditos.`)
};

const de_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliziere die Notenpunkte jedes Kurses mit seinen Kreditstunden, addiere die Ergebnisse und teile durch die Gesamtzahl der Kreditstunden. Das Ergebnis ist dein kreditgewichteter GPA.`)
};

const nl_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldig de cijferpunten van elk vak met de studiepunten, tel ze op, en deel door het totaal aantal studiepunten. Het resultaat is je naar studiepunten gewogen GPA.`)
};

const fr_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliez les points de chaque cours par ses crédits, additionnez le tout, puis divisez par le total des crédits. Le résultat est votre GPA pondéré par crédits.`)
};

const it_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplica i punti voto di ogni corso per i suoi crediti, somma i risultati e dividi per il totale dei crediti. Il risultato è il tuo GPA ponderato sui crediti.`)
};

const pt_br2_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique os pontos de cada disciplina pela sua carga horária, some tudo e divida pelo total de créditos. O resultado é o seu GPA ponderado por créditos.`)
};

const pt_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique os pontos de cada disciplina pelas suas horas de crédito, some tudo e divida pelo total de horas de crédito. O resultado é o seu GPA ponderado por créditos.`)
};

const ja_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各科目の成績点に単位数を掛けて合計し、総単位数で割ります。結果が単位加重GPAです。`)
};

const zh_gpa_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将每门课程的绩点乘以其学分，相加后除以总学分，结果即为学分加权的 GPA。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_a1", locale)
	if (locale === "en") return en_gpa_faq_a1(inputs)
	if (locale === "es") return es_gpa_faq_a1(inputs)
	if (locale === "de") return de_gpa_faq_a1(inputs)
	if (locale === "nl") return nl_gpa_faq_a1(inputs)
	if (locale === "fr") return fr_gpa_faq_a1(inputs)
	if (locale === "it") return it_gpa_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_a1(inputs)
	if (locale === "pt") return pt_gpa_faq_a1(inputs)
	if (locale === "ja") return ja_gpa_faq_a1(inputs)
	return zh_gpa_faq_a1(inputs)
};